module.exports = __webpack_public_path__ + "static/media/07.ed05b5f2.png";